import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Lightning, SignOut, UserCircle } from "@phosphor-icons/react";
import { roleLabel } from "../lib/labels";

export function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  if (!user) return null;
  const roleClass = `role-${user.role}`;

  return (
    <header className="border-b border-[color:var(--border)] bg-[color:var(--surface)] sticky top-0 z-30">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/dashboard" className="flex items-center gap-2" data-testid="nav-logo">
          <Lightning size={22} weight="fill" className="text-[#007AFF]" />
          <span className="font-heading font-black text-lg tracking-tighter">PROJECT PULSE</span>
        </Link>
        <nav className="flex items-center gap-6">
          <Link
            data-testid="nav-projects"
            to="/dashboard"
            className={`label-mono hover:text-white transition ${location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/projects") ? "text-white" : ""}`}
          >
            Projects
          </Link>
          <Link
            data-testid="nav-workload"
            to="/workload"
            className={`label-mono hover:text-white transition ${location.pathname.startsWith("/workload") ? "text-white" : ""}`}
          >
            My workload
          </Link>
          <div className="flex items-center gap-3 pl-6 border-l border-[color:var(--border)]">
            <UserCircle size={24} weight="duotone" className="text-[color:var(--text-secondary)]" />
            <div className="hidden sm:flex flex-col">
              <span data-testid="nav-user-name" className="text-sm font-semibold leading-tight">{user.name}</span>
              <span className={`role-badge ${roleClass} mt-0.5`} data-testid="nav-user-role">{roleLabel(user.role)}</span>
            </div>
            <button data-testid="nav-logout-button" onClick={handleLogout} className="btn-ghost" aria-label="Logout">
              <SignOut size={16} weight="bold" />
              <span className="hidden sm:inline">Logout</span>
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
